<fieldset [formGroup]="dropDownOptionsFunctionalElementGroup" *ngIf="visible$ | async">
    <ng-container *ngrxLet="dropDownOptionsFunctionalElement$ | async; let dropDownOptionsFunctionalElement">
        <div class="row">
            <p class="col-sm-10 col-12" [innerHTML]="dropDownOptionsFunctionalElement?.label"></p>
            <span class="text-end col-sm-2 col-12 filter-text">{{ elementTypeLabel$ | async }}</span>
        </div>
        <ng-container *ngIf="dropDownOptionsFunctionalElement.optionSet as optionSet">
            <ng-container *ngFor="let group of optionSet">
                <label class="col-form-label me-1" [attr.for]="group.title">{{ group.title }}</label>
                <div class="row mb-3" [id]="group.title">
                    <div class="col-md-3 col-12">
                        <pace-forms-dropdown
                            [disabled]="disableDropDown$ | async"
                            [formGroup]="optionSetFormGroup"
                            [dropDownButtonText]="dropDownButtonText(dropDownOptionsFunctionalElement)"
                            [insideClick]="dropDownOptionsFunctionalElement.function === FunctionTypes.MULTI_SELECT"
                        >
                            <li role="menuitem" *ngFor="let option of group.options">
                                <a
                                    (click)="updateDropDownOptions(option)"
                                    class="dropdown-item"
                                    [ngClass]="{
                                        active: option.selected,
                                        'dropdown-item-mobile': isMobile,
                                    }"
                                >
                                    <span
                                        class="form-check d-inline-block"
                                        *ngIf="dropDownOptionsFunctionalElement.function === FunctionTypes.MULTI_SELECT"
                                    >
                                        <input
                                            type="checkbox"
                                            class="form-check-input"
                                            id="{{ option.id }}"
                                            [checked]="option.selected"
                                        />
                                        <label class="form-check-label" for="{{ option.id }}"></label>
                                    </span>
                                    {{ option.label }}
                                </a>
                            </li>
                        </pace-forms-dropdown>
                        <div>{{ selectedOptionsDisplay$ | async }}</div>
                    </div>
                    <div *ngIf="displayNACheckbox$ | async" class="col-6 mt-sm-0 mt-3 text-sm-center">
                        <div class="not-applicable">
                            <div class="checkbox-container">
                                <input
                                    type="checkbox"
                                    id="{{ dropDownOptionsFunctionalElement.id }}-not-applicable"
                                    class="form-control"
                                    [formControl]="checkboxControl"
                                />
                                <label for="{{ dropDownOptionsFunctionalElement.id }}-not-applicable">
                                    <fa-icon *ngIf="checkboxControl.value" [icon]="faCheck" size="2x"></fa-icon>
                                </label>
                            </div>
                            <label
                                translate="F4M_NOT_APPLICABLE_LABEL"
                                for="{{ dropDownOptionsFunctionalElement.id }}-not-applicable"
                            ></label>
                        </div>
                    </div>
                    @if (displayHistoryButton$ | async) {
                        <div class="col-auto ms-auto d-flex align-items-center">
                            <pace-forms-history-button
                                [uniqueId]="dropDownOptionsFunctionalElement.uniqueId"
                            ></pace-forms-history-button>
                        </div>
                    }
                </div>
            </ng-container>
        </ng-container>
        <pace-forms-input-text
            [id]="dropDownOptionsFunctionalElement.xmlId!"
            [label]="dropDownOptionsFunctionalElement.remarksLabel!"
            [formControl]="remarksControl"
            *ngIf="showRemarksField$ | async"
        ></pace-forms-input-text>
    </ng-container>
</fieldset>
